import { Toaster } from '@/components/ui/toaster';
import { useMainContext } from '@/context/main-context';
import CreateAccount from '@/pages/create-account';
import Dashboard from '@/pages/dashboard';
import Login from '@/pages/login';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ProtectedRoute from './pages/protected-route';

function App() {
  const { user, loading, collectionsLoading } = useMainContext();

  return (
    <Router>
      <Toaster />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
